import request from '../utils/request'


export function index(params) {
  return request({
    url: '/corpses',
    method: 'get',
      params
  })
}

export function inventory(params) {
  return request({
    url: '/corpses/inventory',
    method: 'get',
    params
  })
}

  

export function show(id) {
    return request({
      url: `/corpses/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/corpses',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/corpses/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/corpses/${id}`,
      method: 'delete',
    })
  }
